<div class="layout" [ngClass]="layoutClass">
  <div class="container-fluid position-relative h-100">
    <!-- Top Nav Bar with Image START -->
    <div
    [ngClass]="revealIOSInstructions ? 'd-none': 'd-block h-100'">
    <div class="img-box position-relative">
      <div class="banner-img" [ngClass]="imageContainerClass">
        <img [src]="imagePath" [height]="imageHeight" />
      </div>
      <div class="top-img">
        <div class="top-img-box">
          <button tabindex="1" class="py-0 px-0" aria-label="Open navigation menu" (click)="toggleMenu(true);">
            <img src="../../assets/menu.svg" alt="Navigation menu icon">
          </button>
          <div class=" ml-auto my-auto ">
            <a tabindex="2" href="http://sonomaplazahistory.com" target="_blank" rel="noopener noreferrer"
              aria-label="Sonoma Plaza History website link"><img class="logo" src="../../assets/logoCityHall.svg"
                alt="Sonom Plaza History logo"></a>
          </div>
        </div>
      </div>
      <div class="d-flex position-absolute w-100 fixed-bottom offer-images-main" *ngIf="showFeatures">
        <div class="text-center offer-images-box">
          <img class="offer-images" src="../../../assets/np_dollar-sign.svg" alt="">
          <p class="text-white font-weight-bold  mt-2">{{ 'welcomePage.free' | translate }}</p>
        </div>
        <div class="text-center offer-images-box">
          <img class="offer-images" src="../../../assets/walking.svg" alt="">
          <p class="text-white font-weight-bold  mt-2">{{ 'welcomePage.walking' | translate }}</p>
        </div>
        <div class="text-center offer-images-box">
          <img class="offer-images" src="../../../assets/devices.svg" alt="">
          <p class="text-white font-weight-bold  mt-2">{{ 'welcomePage.devices' | translate }}</p>
        </div>
        <div class="text-center offer-images-box">
          <img class="offer-images" src="../../../assets/np_duration.svg" alt="">
          <p class="text-white font-weight-bold fs-2 mt-2">{{ 'welcomePage.1Hour' | translate }}</p>
        </div>
      </div>
      <div class="opacity"></div>
    </div>
    <!-- Top Nav Bar with Image END -->

    <!-- Side Menu START -->
    <nav @menu class="d-flex pb-4" *ngIf="displayMenu">
      <button class="py-3 px-4 mr-2 position-absolute" (click)="toggleMenu(false)">&#x2715;</button>
      <ul class="my-auto pb-5">
        <li class="mt-2">
          <a [appNavigate]="['']">
            {{ 'sideNavBar.home' | translate }}
          </a>
        </li>
        <li class="mt-2">
          <a [appNavigate]="['choose-stop']">
            {{ 'sideNavBar.allStops' | translate }}
          </a>
        </li>
        <li class="mt-2">
          <a (click)="showIOSInstructions();">
            {{ 'sideNavBar.troubleshooting' | translate }}
          </a>
        </li>
        <li class="mt-2">
          <a href="http://www.sonomaplazahistory.com/donate/">
            {{ 'sideNavBar.donate' | translate }}
          </a>
        </li>
        <li class="mt-5 pt-2">
          <a href="http://www.sonomaplazahistory.com/">
            <b>
              {{ 'sideNavBar.exitTour' | translate }}
            </b>
          </a>
        </li>
      </ul>
    </nav>
    <ng-content></ng-content>
  </div>
    <!-- Side Menu END -->
    <!-- IOS Instructions UI START -->
    <div class="w-100 ios-instructions" [class.reveal-instructions]="revealIOSInstructions"
      [ngClass]="revealIOSInstructions ? 'd-block': 'd-none'">
      <div class="gradient"></div>
      <div class="row pt-3">
        <div class="col-auto ml-auto ">
          <button (click)="closeIOS()">&#x2715;</button>
        </div>
      </div>
      <div class="row justify-content-center pt-2 pb-3">
        <div class="col-11 px-2">
          <div class="row">
            <div class="col-5">
              <img src="../../../assets/ios-help.png">
            </div>
            <div class="col-7 my-auto">
              <h1>Troubleshooting Sonoma Plaza History Tour</h1>
            </div>
          </div>
          <h2 class="mt-4">Location Services<br><i>IOS (Apple Devices)</i></h2>
          <p class="mt-4"><b>How to turn Location Services on or off for specific apps</b></p>
          <ol>
            <li class="mt-4">Go to <b>Settings > Privacy > Location Services.</b></li>
            <li class="mt-4">Make sure that Location Services is set to on.</li>
            <li class="mt-4">Scroll down to <b>your preferred web browser app</b>. I.E. <i>Safari</i></li>
            <li class="mt-4">
              Tap the app and select an option listed below:
              <ul>
                <li>
                  <b>Ask Next Time:</b> This allows you to choose Always While Using App, Allow Once, or Don't Allow.
                </li>
                <li>
                  <b>While Using the App: </b> Allows access to Location Services only when the app or one of its
                  features is visible on screen. If an app is set to Whil Using the App, you might see your status bar
                  turn blue with a message that an app is actively using your location.
                </li>
                <li>
                  <b>Always:</b> Allows access to your location even when the app is in the background.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <!-- IOS Instructions UI END -->
  </div>
</div>

